import BasePreview from "@/components/builder/blocks/base"
import { define, prop } from "@/components/builder/utils"

import { DroppablePlaceholder } from "../../utils/Placeholder"

function GridItem({ children, ...props }) {
  if (!children) {
    return <DroppablePlaceholder>
      Drop here
    </DroppablePlaceholder>
  }

  return <BasePreview {...props}>
    <div>
      {children}
    </div>
  </BasePreview>
}

export default define('grid-item', GridItem)
  .property(prop.predefined.customClass())
  .property(...prop.predefined.gridItem())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.container())
  .property(prop.predefined.attributes())
  .defaultProps({
    grid: {
      itemColumn: 1,
      itemRow: 1,
    },
  })
  .build()
